import React from "react";
import { useHistory } from "react-router-dom";
import useWidth from "../hooks/useWidth";

export default function ContinueShopping() {
  const width = useWidth();
  const history = useHistory();

  function handleButton() {
    history.push("/");
  }

  return (
    <button
      type="button"
      className={
        width < 600 ? "w90p primary marupsideh" : "w40p primary marupside1"
      }
      onClick={() => handleButton()}
    >
      Şimdi Alışverişe Dön
    </button>
  );
}
